import request from '@/utils/request'

// 图片管理API
export const imageApi = {
  // 分页查询图片
  getImageList(params) {
    return request({
      url: '/vehicle-image/list',
      method: 'get',
      params
    })
  },

  // 根据图片ID获取图片详情
  getImageDetail(imageId) {
    return request({
      url: `/vehicle-image/detail/${imageId}`,
      method: 'get'
    })
  },

  // 添加图片
  addImage(data) {
    return request({
      url: '/vehicle-image/add',
      method: 'post',
      data
    })
  },

  // 更新图片
  updateImage(data) {
    return request({
      url: '/vehicle-image/update',
      method: 'post',
      data
    })
  },

  // 删除图片
  deleteImage(imageId) {
    return request({
      url: `/vehicle-image/delete/${imageId}`,
      method: 'delete'
    })
  }
}
